import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=133f60b9&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=ts"
export * from "./Callback.vue?vue&type=script&lang=ts"
import style0 from "./Callback.vue?vue&type=style&index=0&id=133f60b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f60b9",
  null
  
)

export default component.exports